import { render, staticRenderFns } from "./Xs500White.vue?vue&type=template&id=ffb42cfe&scoped=true&"
var script = {}
import style0 from "./Xs500White.vue?vue&type=style&index=0&id=ffb42cfe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffb42cfe",
  null
  
)

export default component.exports